/*
 * "Your Privacy Choices" — the CPRA opt-out control in the footer.
 *
 * Shopify provisions the opt-out and adds it to the footer menu, but it is not a URL and
 * Liquid never sees it: linklists.footer returns only the ordinary items. So a link in a
 * menu cannot carry it and the control has to call the Customer Privacy API directly.
 *
 * setTrackingConsent({ sale_of_data: false }) is used rather than setCCPAConsent, because
 * it was verified against the live API — it moves sale_of_data to "no", saleOfDataAllowed
 * to false and userDataCanBeSold to false — whereas setCCPAConsent reports zero arity and
 * the sense of its argument is not documented.
 */
(() => {
  const READY = 'visitorConsentCollected';

  const api = () => (window.Shopify && window.Shopify.customerPrivacy) || null;

  function state(button) {
    const a = api();
    if (!a || typeof a.saleOfDataAllowed !== 'function') return;
    const optedOut = a.saleOfDataAllowed() === false;
    button.classList.toggle('is-opted-out', optedOut);
    const label = button.querySelector('[data-privacy-choices-label]');
    if (label && optedOut) label.textContent = button.dataset.confirmedLabel || 'You have opted out';
    button.setAttribute('aria-pressed', optedOut ? 'true' : 'false');
  }

  function optOut(button) {
    const a = api();
    if (!a || typeof a.setTrackingConsent !== 'function') {
      // The API has not loaded; send the shopper to the policy rather than failing silently.
      if (button.dataset.fallbackUrl) window.location.href = button.dataset.fallbackUrl;
      return;
    }
    button.disabled = true;
    a.setTrackingConsent({ sale_of_data: false }, () => {
      button.disabled = false;
      state(button);
    });
    // The callback is not guaranteed to fire on every path, so the label is settled either way.
    setTimeout(() => {
      button.disabled = false;
      state(button);
    }, 2500);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-privacy-choices]');
    if (!button) return;
    event.preventDefault();
    optOut(button);
  });

  function sync() {
    document.querySelectorAll('[data-privacy-choices]').forEach(state);
  }

  // The Customer Privacy API loads after the page, and visitorConsentCollected fires only
  // when a choice changes — so on a return visit neither path sees the stored opt-out.
  // Wait for the API to appear, then settle the label once.
  function syncWhenReady(tries = 0) {
    const a = api();
    if (a && typeof a.saleOfDataAllowed === 'function') return sync();
    if (tries < 40) setTimeout(() => syncWhenReady(tries + 1), 250);
  }

  document.addEventListener(READY, sync);
  if (document.readyState !== 'loading') syncWhenReady();
  else document.addEventListener('DOMContentLoaded', () => syncWhenReady());
})();
